// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ec7a3274","189":"8ef7f37f","331":"4a855615","453":"02cace9c","555":"d7e4fa9a","615":"e5aa7619","818":"721efcee"}[chunkId] + ".chunk.js";
};